document.addEventListener('DOMContentLoaded', function() {
  // Check if we're on a product page
  if (window.location.pathname.includes('/products/')) {
    // Find all buttons with the shop-drinks-button class and hide them
    const buttons = document.querySelectorAll('.shop-drinks-button');
    buttons.forEach(button => {
      button.style.display = 'none';
    });
  }
});